import { StyleSheet, Platform } from "react-native";

import { cardShadow } from "../../../../styles/shadows";
import AppTheme from "../../AppTheme";

const cardStyles = StyleSheet.create({
  container: {
    position: "relative",
    zIndex: 11,
    marginTop: 8,
  },
  card: {
    position: "relative",
    marginHorizontal: 8,
    backgroundColor: "#FFFFFF",
    borderRadius: 4,
    paddingVertical: 10,
    paddingHorizontal: 10,
    minHeight: 190,
    display: "flex",
    ...cardShadow,
  },
  header: {
    height: 40,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  headerInfo: {
    height: "100%",
    flex: 1,
    display: "flex",
    justifyContent: "center",
  },
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    zIndex: 2,
  },
  subTitle: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  date: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    zIndex: 2,
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  textContainer: {
    width: "auto",
    maxWidth: 227,
    borderRadius: 10,
    padding: 10,
    paddingBottom: 9,
    marginTop: 20,
    marginRight: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F4F6FA",
    ...cardShadow,
  },
  cardText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    textAlign: "center",
  },
  cardTextThin: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.175,
    color: "#2D3142",
  },
  image: {
    width: 90,
    height: 116,
    aspectRatio: 1,
  },
  buttons: {
    width: "100%",
    marginTop: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 180,
    height: 40,
    maxWidth: "100%",
    backgroundColor: AppTheme.DEFAULT_COLOR,
  },
  buttonSmall: {
    width: "auto",
    minWidth: 104,
    height: 32,
    backgroundColor: AppTheme.DEFAULT_COLOR,
    paddingHorizontal: 10,
    borderRadius: 6,
  },
  buttonText: {
    color: "#FFF",
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 40,
    letterSpacing: 1,
  },
  buttonSmallText: {
    color: "#FFF",
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  buttonWhite: {
    backgroundColor: "#F4F6FA",
    marginBottom: 8,
  },
  buttonWhiteText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "normal",
    fontSize: 14,
    lineHeight: 40,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  messageContainer: {
    marginTop: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 6,
  },
  input: {
    backgroundColor: "#F3F2F1",
    borderRadius: 4,
    padding: 10,
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: "#2D3142",
    width: "100%",
  },
  separator: {
    width: "100%",
    height: 1,
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
    marginVertical: 8,
  },
  closeButton: {
    position: "absolute",
    right: 6,
    top: 6,
    width: 15,
    height: 15,
  },
  goal: {
    shadowOpacity: 0,
    marginBottom: 0,
    paddingHorizontal: 0,
    paddingTop: 0,
  },
});

export default cardStyles;
